import { render } from "./PembayaranModal_c.vue?vue&type=template&id=a98189d2&scoped=true"
import script from "./PembayaranModal_c.vue?vue&type=script&lang=js"
export * from "./PembayaranModal_c.vue?vue&type=script&lang=js"

import "./PembayaranModal_c.vue?vue&type=style&index=0&id=a98189d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a98189d2"

export default script